import React from 'react';
import Header from '../components/Header';

export const AuthLayout = ({ children }) => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-purple-50 dark:from-gray-900 dark:via-gray-900 dark:to-gray-800">
      <Header />
      <div className="flex items-center justify-center min-h-[calc(100vh-80px)] px-4 py-8 sm:py-12">
        <div className="w-full max-w-sm">
          {children}
        </div>
      </div>
    </div>
  );
};
